import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';

@Component({
  selector: 'app-brunch-preview',
  templateUrl: './brunch-preview.component.html',
  styleUrls: ['./brunch-preview.component.css',]
})
export class BrunchPreviewComponent implements OnInit, OnDestroy {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    autoWidth: true,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }
  brunchItem: any;
  sampleImageList = [];
  lastPublishedDate: any;
  storyElementArray = []
  @ViewChild('embedEl', { static: false }) embedElement: ElementRef;

  constructor() { }
  ngOnDestroy() {
    sessionStorage.removeItem('brunchItem');
  }

  ngOnInit() {
    this.brunchItem = JSON.parse(sessionStorage.getItem('brunchItem'));
    this.storyElementArray = this.brunchItem.storyElement;
    this.lastPublishedDate = this.brunchItem.lastPublishedDate !== null ? moment(this.brunchItem.lastPublishedDate).format('MMMM Do YYYY, h:mm:ss a') : '';
  }
}
